import {useMutation, UseMutationResult} from '@tanstack/react-query';
import {useLocale} from 'state/locale';
import Api from 'types/api';
import {toSnakeCase} from 'utils/object';
import {request} from 'utils/request-axios';

import {FormData} from './types';

type PossibleResponses = Api.Response.SuccessAxios;
type UsePostClientDXSettings = {
    clientMid: string;
    formData: FormData;
};

const useDXSettings = (): UseMutationResult<
    PossibleResponses,
    Error,
    UsePostClientDXSettings
> => {
    const locale = useLocale();
    return useMutation({
        mutationFn: ({clientMid, formData}: UsePostClientDXSettings) =>
            request({
                formData: toSnakeCase(formData),
                locale,
                method: 'POST',
                url: `/home/client/${clientMid}/dxsettings/edit/post`,
            }),
    });
};

export default useDXSettings;
